import { lazy, Suspense } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { motion, useReducedMotion } from "framer-motion";
import PageLoading from "../components/ui/PageLoading";

const Home = lazy(() => import("../pages/Home"));
const About = lazy(() => import("../pages/About"));
const Blog = lazy(() => import("../pages/Blog"));
const BlogDetail = lazy(() => import("../pages/BlogDetail"));
const Prompts = lazy(() => import("../pages/Prompts"));
const TagPage = lazy(() => import("../pages/TagPage"));
const Projects = lazy(() => import("../pages/Projects"));
const Contact = lazy(() => import("../pages/Contact"));

function RouteMotion({ children }: { readonly children: React.ReactNode }) {
  const location = useLocation();
  const reduce = useReducedMotion();

  return (
    <motion.div
      key={location.pathname}
      initial={reduce ? false : { opacity: 0, y: 14 }}
      animate={reduce ? undefined : { opacity: 1, y: 0 }}
      transition={{ duration: 0.24, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}

export default function AppRouter() {
  const location = useLocation();

  return (
    <Suspense fallback={<PageLoading />}>
      <RouteMotion>
        <Routes location={location}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogDetail />} />
          <Route path="/prompts" element={<Prompts />} />
          <Route path="/tags/:tag" element={<TagPage />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </RouteMotion>
    </Suspense>
  );
}
